module.exports = __webpack_public_path__ + "img/3.1c9e7d13.jpg";